import store from '@/store/index.js';
import modeConst from '@/consts/mode.const.js';
import genericTabsPathConst from '@/consts/genericTabsPath.const.js';
import comparableSetConst from '@/consts/comparableSet.const.js';

/**
 *  This guard is in charge of loading the data for the searches and of performing the redirection
 *  to the tab of comparable that has been selected in the search. It also checks if you try to access
 *  a comparables tab other than the one selected in the search, in which case it redirects to the one
 *  selected in the search.
 *
 *  The tabs action controls that the call is only made once.
 */
const pixResearchGuard = async (to, from, next) => {
  store.commit('setMode', modeConst.RESEARCH);
  store.dispatch('toolbarModule/hideToolbar');

  const searchId = store.getters['researchModule/getSelectedSearch']?.SearchId;
  if (searchId !== to.params.searchId) {
    await Promise.all([store.dispatch('researchModule/loadResearchTabs'), store.dispatch('researchModule/fetchSearchById', to.params.searchId)]);
    const searchTab = store.getters['researchModule/getSelectedSearch']?.TabTypeId;
    const tabId = store.getters['genericConfigModule/getTab'](searchTab, modeConst.RESEARCH)?.RowId;
    const selectedTab = store.getters['researchModule/getSelectedTab'];

    store.dispatch('comparablesModule/setSelectedTab', selectedTab);
    store.dispatch('comparablesModule/setSelectedComparableSet', { set: comparableSetConst.ALL, tab: selectedTab });
    store.dispatch('comparablesModule/fetchComparablesBaskets', { relationId: to.params.searchId, selectedTab });
    store.dispatch('genericConfigModule/loadGenericTabConfig', tabId);

    const comparablePath = genericTabsPathConst[selectedTab];
    // Check if the path has only the id or if it already has also the comparablePath
    if (to.matched?.length < 2) {
      if (comparablePath) {
        next(`${to.path}/${comparablePath}`);
      } else {
        next(from.path);
      }
    } else {
      // In case you have the comparablePath, check that the id of the path is the
      // same as that of the search that is stored in the store
      const pathParts = to.path.split('/');
      if (pathParts[3] !== comparablePath) {
        next(`${pathParts[1]}/${pathParts[2]}/${comparablePath}`);
      } else {
        next();
      }
    }
  } else {
    next();
  }
};

export default pixResearchGuard;
